<script>
	// https://svelte.dev/docs#createEventDispatcher
	// tutorial/05-events/04-component-events
	import { createEventDispatcher } from "svelte";
	import Product from "./Product.svelte";
	const dispatch = createEventDispatcher();

	import UTILS from "./classes/utilities.js";

	import Supplements from "./Supplements.svelte";

	export let productOrder;
	export let supplements = [];

	function needsUpdate() {
		productOrder = productOrder;
	}

	function supplementIncrement(supplement) {
		productOrder.supplementIncrement(supplement);
		console.log("ProductOrder.supplementIncrement", productOrder);
		dispatch("productOrderChanged", productOrder);
		needsUpdate();
	}

	function supplementDecrement(supplement) {
		productOrder.supplementDecrement(supplement);
		console.log("ProductOrder.supplementDecrement", productOrder);
		dispatch("productOrderChanged", productOrder);
		needsUpdate();
	}

	function increment() {
		productOrder.increment();
		dispatch("productOrderChanged", productOrder);
		needsUpdate();
	}

	function decrement() {
		productOrder.decrement();
		dispatch("productOrderChanged", productOrder);
		needsUpdate();
	}

	function deleteVariant() {
		productOrder.empty();
		dispatch("productOrderChanged", productOrder);
		needsUpdate();
	}

	function hasSupplements() {
		return productOrder.hasSupplements();
	}
</script>

{#if productOrder}
	<div class="product-order">
		{productOrder.product.name}
		<button on:click={() => decrement()} class="calculator minus"></button>
		<span class="quantity">{productOrder.quantity}</span>
		<button on:click={() => increment()} class="calculator plus"></button>
		<button on:click="{() => deleteVariant()}" class="close"></button>
	</div>
	{#if hasSupplements() && productOrder.quantity > 0}
		<span class='price'>{UTILS.formatMoney(productOrder.getPrice())}</span>
		<div class="product-supplements">
			<Supplements
				{supplements}
				supplement_group={productOrder.supplement_group}
				on:supplementIncrement={(ev) => supplementIncrement(ev.detail)}
				on:supplementDecrement={(ev) => supplementDecrement(ev.detail)}
			/>
		</div>
	{/if}
{/if}

<style>
	.product-order:nth-child(odd) {
		background-color: #eee;
	}

	.product-order {
		border: 2px solid black;
		display: flex;
	}
</style>
